module.exports = flarum.core.compat['tags/common/models/Tag'];